import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Theme } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import MDBox from "@/components/atoms/MDBox";
import { useMaterialUIController } from "@/contexts/mui-context";

import {
  collapseArrow,
  collapseIcon,
  collapseIconBox,
  collapseItem,
  collapseText,
} from "./styles/sidenavCollapse";

interface SidenavCollapseProps {
  icon: React.ReactNode;
  name: string;
  children?: React.ReactNode;
  active: boolean;
  noCollapse?: boolean;
  open?: boolean;
  onClick?: () => void;
  isContractNow?: boolean;
}

function SidenavCollapse({
  icon,
  name,
  children,
  active,
  noCollapse = false,
  open = false,
  onClick,
  isContractNow,
  ...rest
}: SidenavCollapseProps) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller;

  return (
    <>
      <ListItem component="li">
        <MDBox
          onClick={onClick}
          {...rest}
          sx={(theme: Theme) => ({
            ...collapseItem(theme, {
              active,
              transparentSidenav,
              whiteSidenav,
              darkMode,
            }),
            ...(isContractNow && {
              background: theme.palette.primary.main,
              "&:hover, &:focus": {
                backgroundColor: theme.palette.primary.focus,
              },
            }),
          })}
        >
          <ListItemIcon
            sx={(theme) =>
              collapseIconBox(theme, {
                transparentSidenav,
                whiteSidenav,
                darkMode,
              })
            }
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) =>
              collapseText(theme, {
                miniSidenav,
                transparentSidenav,
                whiteSidenav,
                active,
              })
            }
          />
          {!noCollapse && (
            <ExpandLessIcon
              sx={(theme) =>
                collapseArrow(theme, {
                  noCollapse,
                  transparentSidenav,
                  whiteSidenav,
                  miniSidenav,
                  open,
                  active,
                  darkMode,
                })
              }
            />
          )}
        </MDBox>
      </ListItem>
      {children && (
        <Collapse in={open} timeout={{ enter: 250, exit: 200 }}>
          {children}
        </Collapse>
      )}
    </>
  );
}

export default SidenavCollapse;
